module.exports = __webpack_public_path__ + "img/section_1-svg_2.b5ac0136.svg";